// removed by extract-text-webpack-plugin
module.exports = {"BlockerInfo":"BlockerInfo__BlockerInfo__EZ9iS"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/TilesInfo/BlockerInfo.css
// module id = 239
// module chunks = 0